import React, { useState } from "react";
import "./UslugiBlock.scss";
import TransitionedBlock from "../../../HelperComponents/TransitionedBlock/TransitionedBlock";
import man from "../../../../public/images/man.svg";
import stack from "../../../../public/images/stack.svg";
import box_man from "../../../../public/images/box man.svg";
import Vector_ok from "../../../../public/images/Vector_ok.svg";
import truck from "../../../../public/images/truck.svg";
import profile1 from "../../../../public/images/profile 1.svg";
import robot from "../../../../public/images/robot-arm 1.svg";
import paint_bucket from "../../../../public/images/paint-bucket.svg";
import delivery from "../../../../public/images/delivery-man 1.svg";
import { withTranslation } from "../../../../i18n";
import Head from "next/head";

const UslugiBlock = ({ t }) => {
    return (
        <TransitionedBlock>
            <Head>
                <title>{t("Услуги")} │ PRORAB</title>
            </Head>
            <div className="uslugi_wrapper">
                <h1 className="title">{t("Услуги")}</h1>
                <div id={`remont`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Сантехнические работы")}
                                </span>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Электротехнические работы")}
                                </span>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Укладка плитки")}
                                </span>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Внутренние работы")}
                                </span>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Установка системы «теплый пол»")}
                                </span>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Демонтажные работы")}
                                </span>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Выравнивание пола")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t(
                                            "В интернет-магазине PRORAB каждый клиент может найти эксперта для выполнения ряда строительных работ"
                                        )}
                                        : <br />
                                        <br />{" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p className="medium">1.</p>{" "}
                                    <p>
                                        {t("Сантехнические работы")} (монтаж/демонтаж труб,{" "}
                                        {t("установка раковин, унитазов, бойлеров и др")}.).{" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p className="medium">2.</p>{" "}
                                    <p>
                                        {t("Электротехнические работы")} (
                                        {t(
                                            "монтаж светильников, розеток и других приборов, прокладка кабеля, замена систем электричества"
                                        )}
                                        ).{" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p className="medium">3.</p>{" "}
                                    <p>
                                        {t("Укладка плитки")} (
                                        {t("грунтовка стяжки, укладка плитки на пол и стены, резка и шлифовка плиток")}
                                        ).{" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p className="medium">4.</p>{" "}
                                    <p>
                                        {t("Внутренние работы")} (
                                        {t(
                                            "выравнивание стен и потолков, их покраска, стяжка пола, облицовка стен, поклейка обоев и"
                                        )}{" "}
                                        т.д.).{" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p className="medium">5.</p>{" "}
                                    <p>
                                        {t("Установка системы «теплый пол»")} (
                                        {t(
                                            "монтаж систем подогрева и терморегуляторов, расчет стоимости и энергопотребления пола"
                                        )}
                                        ).{" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p className="medium">6.</p>{" "}
                                    <p>
                                        {t("Демонтажные работы")} (
                                        {t(
                                            "снос стен, полов, потолков, окон, дверей, проемов, демонтаж сантехники, электрики, штробление стен и др"
                                        )}
                                        .){" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p className="medium">7.</p>{" "}
                                    <p>
                                        {t(
                                            "Выравнивание пола с помощью бетонной стяжки, фанеры, самовыравнивающейся смеси"
                                        )}
                                        .<br />
                                        <br />{" "}
                                    </p>{" "}
                                </span>
                                <span>
                                    <p>
                                        {t(
                                            "Все услуги проводят опытные специалисты, которые делают все работы максимально быстро, качественно и аккуратно"
                                        )}
                                        . {t("Рассчитать прайс услуг можно в телефонном режиме у нашего менеджера")}.{" "}
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={man} alt="man" />
                            {t("Подбор эксперта для выполнения ремонтно-строительных работ")}
                        </div>
                    </div>
                </div>
                <div id={`montaj`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("От расчета до монтажа")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t(
                                            "В интернет-магазине PRORAB работают опытные специалисты, которые занимаются продажей и установкой натяжных потолков"
                                        )}
                                        . {t("Мы проведем весь комплекс работ")} -{" "}
                                        {t("от расчета до монтажа потолка любой сложности")}.{" "}
                                        {t(
                                            "Чтобы получит качественные услуги по доступной цене, позвоните нашим менеджерам и оставьте заявку"
                                        )}
                                        .{" "}
                                        {t(
                                            "Это поможет Вам быстро и правильно определиться с видом натяжного потолка, а также просчитать количество материалов и стоимость монтажных работ"
                                        )}
                                        .{" "}
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={stack} alt="stack" />
                            {t("Монтаж натяжных потолков")}
                        </div>
                    </div>
                </div>
                <div id={`delivery`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Доставка товара до дверей")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t("Если Вам нужно доставить товары по")} {t("г")}. Полтава,{" "}
                                        {t("тогда Вам не обойтись без ответственных курьеров и быстрой доставки")}.{" "}
                                        {t(
                                            "Интернет-магазин PRORAB предлагает услугу доставки товаров к двери каждого клиента"
                                        )}
                                        . {t("Стоимость услуги оговаривается индивидуально при согласовании заказа")}.
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={delivery} alt="delivery" />
                            {t("Доставка товаров")}
                        </div>
                    </div>
                </div>
                <div id={`movers`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Подъем груза на этаж")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t(
                                            "Грузчики интернет-магазина PRORAB - это настоящие профессионалы, которые быстро, качественно и безопасно проведут погрузочные работы"
                                        )}
                                        .{" "}
                                        {t(
                                            "Оставляя заявку нашему менеджеру, укажите этаж доставки, объем груза и другие его особенности"
                                        )}
                                        .
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={box_man} alt="box_man" />
                            {t("Услуги грузчиков")}
                        </div>
                    </div>
                </div>
                <div id={`garbage`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Загрузка, вывоз, утилизация")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t(
                                            "Интернет-магазин PRORAB предлагает комплекс профессиональных услуг по вывозу мусора в"
                                        )}{" "}
                                        {t("г")}. Полтава.{" "}
                                        {t(
                                            "Оформляя эту услугу у нас, укажите тип мусора, его объем и вес, время и день подачи транспорта"
                                        )}
                                        .
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={truck} alt="truck" />
                            {t("Вывоз строительного мусора")}
                        </div>
                    </div>
                </div>
                <div id={`paint`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Подбор необходимого цвета")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t(
                                            "Благодаря нашей услуге «колеровка красок» Вы сможете получить необходимый оттенок на основе базовой краски"
                                        )}
                                        .{" "}
                                        {t(
                                            "Наши специалисты помогут подобрать краску или штукатурку необходимого цвета или заказать оттенок, которого нет у производителей"
                                        )}
                                        .{" "}
                                        {t(
                                            "Мы используем лучшие водоэмульсионные, синтетические пасты, которые не выгорают и имеют экологически безопасный состав"
                                        )}
                                        .
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={paint_bucket} alt="paint-bucket" />
                            {t("Колеровка красок и декоративных штукатурок")}
                        </div>
                    </div>
                </div>
                <div id={`manipulyator`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Для крупногабаритных товаров")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t(
                                            "Если Вам нужно перевезти, загрузить или выгрузить крупногабаритные товары, тогда Вам не обойтись без спецтехники с высоким уровнем производительности и отличным функционалом"
                                        )}
                                        .{" "}
                                        {t(
                                            "В интернет-магазине PRORAB Вы можете арендовать манипулятор и другую технику на выгодных условиях"
                                        )}
                                        .
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={robot} alt="paint-bucket" />
                            {t("Услуги манипулятора")}
                        </div>
                    </div>
                </div>
                <div id={`individual_manager`}>
                    <div className="border_block">
                        <div className="color">
                            <div>
                                <div className="red_text">{t("Описание")}:</div>
                                <span>
                                    <img src={Vector_ok} alt="Vector_ok" />
                                    {t("Количественный расчет материалов")}
                                </span>
                            </div>
                            <div>
                                <div className="red_text">{t("Детализация услуг")}</div>
                                <span>
                                    <p>
                                        {t(
                                            "Менеджеры интернет-магазина  PRORAB сориентируют каждого покупателя в широком ассортименте строительных материалов и товаров для дома, помогут выбрать самый лучший вариант, расчитать количество и стоимость нужных товаров"
                                        )}
                                        .{" "}
                                        {t(
                                            "Проконсультироваться можно онлайн при покупке на сайте или посетив нашы магазины"
                                        )}
                                        .
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div className="icon">
                            <img src={profile1} alt="profile" />
                            {t("Индивидуальный менеджер")}
                        </div>
                    </div>
                </div>
            </div>
        </TransitionedBlock>
    );
};

export default withTranslation("infoPages")(UslugiBlock);
